import React, { useState } from 'react';
import Modal from './Modal';

export default function AssignModal({ drawResult, users, onAssign, onCancel }) {
  const [selectedUser, setSelectedUser] = useState('');
  const [name, setName] = useState('');
  const [overwrite, setOverwrite] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  // Leads im Gebiet, die schon jemand anderem gehören — vorher wurden sie stillschweigend
  // umgehängt, der bisherige Vertriebler hat sie einfach verloren.
  const takenBy = {};
  for (const l of drawResult.leads) {
    if (l.assigned_to && l.assigned_to !== selectedUser) takenBy[l.assigned_to] = (takenBy[l.assigned_to] || 0) + 1;
  }
  const takenCount = Object.values(takenBy).reduce((s, n) => s + n, 0);
  const effectiveLeads = overwrite
    ? drawResult.leads
    : drawResult.leads.filter(l => !l.assigned_to || l.assigned_to === selectedUser);

  const handleAssign = async () => {
    if (!selectedUser) return;
    setSaving(true);
    setError('');
    try {
      await onAssign({
        geoJson: drawResult.geoJson,
        lead_ids: effectiveLeads.map(l => l.id),
        assigned_to: selectedUser,
        name,
      });
    } catch (err) {
      console.error('Fehler beim Zuweisen:', err);
      setError('Zuweisen fehlgeschlagen — bitte Verbindung prüfen und erneut versuchen.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal onClose={onCancel} label="Gebiet zuweisen">
        <h2 style={{ marginBottom: 4 }}>Gebiet zuweisen</h2>
        <p style={{ fontSize: 13, color: '#374151', marginBottom: 20 }}>
          <strong style={{ color: '#1e1b4b' }}>{drawResult.leads.length} Leads</strong> im gezeichneten Gebiet
        </p>

        <div className="form-grid">
          <div className="form-field full-width">
            <label>Gebietsname (optional)</label>
            <input value={name} onChange={e => setName(e.target.value)} placeholder="z.B. Bad Driburg Nord" />
          </div>
          <div className="form-field full-width">
            <label>Zuweisen an</label>
            <select value={selectedUser} onChange={e => setSelectedUser(e.target.value)} required>
              <option value="">— Benutzer wählen —</option>
              {users.filter(u => u.role !== 'admin').map(u => (
                <option key={u.id} value={u.username}>{u.username}</option>
              ))}
            </select>
          </div>
        </div>

        {takenCount > 0 && (
          <div style={{ background: '#fef9c3', border: '1px solid #fde047', borderRadius: 8, padding: '10px 12px', fontSize: 13, color: '#713f12', marginTop: 12 }}>
            <div>
              <strong>{takenCount} davon bereits zugewiesen:</strong>{' '}
              {Object.entries(takenBy).sort((a, b) => b[1] - a[1]).map(([u, n]) => `${u} ×${n}`).join(', ')}
            </div>
            <label style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 8, cursor: 'pointer' }}>
              <input type="checkbox" checked={overwrite} onChange={e => setOverwrite(e.target.checked)} />
              Diese Leads überschreiben (dem bisherigen Vertriebler entziehen)
            </label>
            {!overwrite && (
              <div style={{ fontSize: 12, marginTop: 6, color: '#854d0e' }}>
                Ohne Haken werden nur die {effectiveLeads.length} nicht vergebenen Leads zugewiesen.
              </div>
            )}
          </div>
        )}

        {drawResult.leads.length === 0 && (
          <div style={{ background: '#fef9c3', border: '1px solid #fde047', borderRadius: 8, padding: '8px 12px', fontSize: 13, color: '#713f12', marginTop: 12 }}>
            Keine Leads in diesem Gebiet gefunden.
          </div>
        )}

        {error && (
          <div className="login-error" role="alert" style={{ marginTop: 12 }}>{error}</div>
        )}

        <div className="form-actions" style={{ marginTop: 20 }}>
          <button type="button" className="btn btn-secondary" onClick={onCancel}>Abbrechen</button>
          <button
            type="button"
            className={`btn btn-gradient${saving ? ' btn-loading' : ''}`}
            onClick={handleAssign}
            disabled={!selectedUser || effectiveLeads.length === 0 || saving}
            aria-busy={saving}
          >
            {saving ? 'Wird zugewiesen...' : error ? 'Erneut versuchen' : `${effectiveLeads.length} Leads zuweisen`}
          </button>
        </div>
    </Modal>
  );
}
